import React, { Component } from 'react';
import Utils from '../../utils';

export default class OPComponent extends Component {
  constructor(props) {
    super(props);
    Utils.initSlowlog(this, /.*/);
  }
}
